import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useListAttributesByEntityQuery } from "@/services/customAtrributes/customAttributesReducer";
import { setCreditorAttributes } from "./CreditorAttributesSlice";
import { useTranslation } from "react-i18next";
import CustomAttribute from "@/components/CustomAttribute/CustomAtrribute";
import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifErrorMessage,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import Button from "@/components/Form/Button/Button";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { AttributeType } from "../../Configuration/Attributes/type";
import { useNavigate } from 'react-router-dom';
import { useCase } from "@/features/case/use-case";
import { resetCreditorSetup, updateFormSubmitIndex, updateStage } from "./creditorSetupSlice";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { CANCEL_BUTTON_VARIANT, NEXT_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { ActiveTabsOrder } from "@/menuData";
import NotificationGrid from "@/components/Notification/NotificationGrid";

export default function CreditorAttributes() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const caseData = useCase();
  const [isFormOpen, setIsFormOpen] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [notificationVisible, setNotificationVisible] = useState(false);

  const { data: attributesDataValue ,isLoading:attributesLoading} = useListAttributesByEntityQuery({
    CaseId: caseData.caseId,
    EntityType: 1,
    IsCreate: true,
  });
  const [attributesData, setAttributesData] = useState<any>(undefined);
  const [customAttributesValue,setCustomAttributesValues]=useState<any>([])
  // let attributesData :any=undefined
const hideDocumnetAttribute=()=>{
  let filteredAttributes :any = []
  if (attributesDataValue) {
    filteredAttributes = attributesDataValue?.filter((x: any) => {
      return x.value.attributeType !== AttributeType.Document;
    });
   
  }
return filteredAttributes
}
  const attributesValue = useSelector(
    (state: any) => state.creditorAttributes.attributes
  );

  const formSubmitIndex = useSelector(
    (state: any) => state.formSubmitIndex
  );
  useEffect(() => {
    dispatch(setDiscardEditMode({ editMode: true }));
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch]);
  useEffect(() => {
    const attributes = hideDocumnetAttribute();
    setAttributesData(attributes);
    if (attributes && attributesValue.length === 0) {
      setCustomAttributesValues([...attributes]);
    }
    else{
      setCustomAttributesValues([...attributesValue]);
    }
    // eslint-disable-next-line
  }, [attributesDataValue]);
useEffect(()=>{
  dispatch(setCreditorAttributes(customAttributesValue));

},[customAttributesValue,dispatch])


  const isDisabled = () => {
    var disabled = false;
    const numberNotInRangeLabels :any=[]
    const required = attributesValue.filter((x: any) => {
      if (x.value.attributeType === AttributeType.Number) {
        let metaData=JSON.parse(x.metadataJSON);
        if (!(Number(x.value.numberValue) >=Number(metaData.minimum) &&  Number(x.value.numberValue) <= Number(metaData.maximum)) && x.value.numberValue !== "" && x.value.numberValue !== null) {
          numberNotInRangeLabels.push(x.name);
        }
      }
      return x.isRequired;
    });
    if(numberNotInRangeLabels.length>0){
      setNotificationVisible(true);
      setNotification({
        ...notification,
        ...notification,
        show: true,
        message: t("global.globalNotifications.numberOutOfRange",{attributeName:numberNotInRangeLabels?.join(",")}),
        type: "error",
      });
      return true
    }

    required.find((x: any) => {
      switch (x.value.attributeType) {
        case AttributeType.FreeText:
          disabled = !x.value.textValue;
          break;
        case AttributeType.Number:
          disabled = !x.value.numberValue && x.value.numberValue !== 0;
          break;
        case AttributeType.Boolean:
          disabled = !x.value.booleanValue && x.value.booleanValue !== false;
          break;
        case AttributeType.Date:
          disabled = !x.value.dateValue;
          break;
        case AttributeType.SingleSelect:
          disabled = !x.value.selectedValue;
          break;
        case AttributeType.MutliSelect:
          disabled =
            !x.value.selectedValues || x.value.selectedValues.length === 0;
          break;
        case AttributeType.Currency:
          disabled = !x.value.amount;
          break;
        // case AttributeType.Document:
        //   disabled = !x.value.displayName;
        //   break;
        default:
          disabled = false;
      }
      return disabled
    });

    return disabled;
  };

  let missingRequiredFieldsList = useCallback(() => {
    const errorFieldsList: string[] = [];
    var isError = false;
    const required = attributesValue?.filter((x: any) => {  
      return x.isRequired;
    });
    required?.map((x: any) => {
      switch (x.value.attributeType) {
        case AttributeType.FreeText:
          isError = !x.value.textValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Number:
          isError = !x.value.numberValue && x.value.numberValue !== 0;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Boolean:
          isError = !x.value.booleanValue && x.value.booleanValue !== false;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Date:
          isError = !x.value.dateValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.SingleSelect:
          isError = !x.value.selectedValue;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.MutliSelect:
          isError =
            !x.value.selectedValues || x.value.selectedValues.length === 0;
          return isError && errorFieldsList.push(x.name);
        case AttributeType.Currency:
          isError = x.value.amount === 0 || x.value.amount ? false : true;
          return isError && errorFieldsList.push(x.name);
      }
      return true;
    });
    setErrorFields(errorFieldsList);
    return errorFieldsList;
  }, [attributesValue]);

  const handleNext = () => {
    if(missingRequiredFieldsList().length > 0){
      return;
    }
    if (isDisabled()) {
      setIsError(true);
    } else {
      setIsError(false);
      dispatch(updateStage(3));
      formSubmitIndex !== 3 && dispatch(updateFormSubmitIndex(2)); 
    }
  };

  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    dispatch(resetCreditorSetup());
    dispatch(setCreditorAttributes([]));
    dispatch(updateStage(0));
    dispatch(setCreditorAttributes(attributesData));
    setIsVisible(false);
    navigate(`/case/${caseData?.caseId || ""}/?activeTab=${ActiveTabsOrder.CREDITOR}`);
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisible(false);
    dispatch(setDiscardEditMode({ editMode: true }));

  };

  return (
    <div className="motif-container pad-l-40 pad-r-20">
      {notificationVisible && (
              <NotificationGrid
                show={notification.show}
                message={notification.message}
                type={notification.type}
                onClose={()=>setNotification({
                  show: false,
                  message: "",
                  type: "success",
                })}
              />
            )}
      <div className="motif-row t-b-padding-21">
        <div className="motif-col-xs-4">
          <p className="form-title motif-h5-default-regular">
            {t("pages.creditors.creditorForm.creditorAttributesTitle")}
          </p>
          <p className="form-description">{t("pages.creditors.creditorForm.creditorAttributesDescription")}</p>
        </div>
      </div>
      <MotifAccordion
        onClose={() => setIsFormOpen(false)}
        onOpen={() => setIsFormOpen(true)}
        style={{
          flex: "1",
        }}
        open={isFormOpen}
        useChevronIcon={true}
        alignIconRight={true}
      >
        <MotifAccordionTrigger>
          {t("pages.creditors.creditorForm.formLabelDetails.creditorAttributes")}
        </MotifAccordionTrigger>
        <MotifAccordionContent>
          {attributesLoading ? (
            <MotifProgressLoader show variant="default" />
          ) : (
            <div className="pad-v-25 motif-row">
              {attributesData &&
              attributesValue.length === attributesData.length ? (
                attributesData.map((attribute: any, index: number) => {
                  return (
                    <>
                      <CustomAttribute
                        customAttributeDetails={{
                          ...attribute,
                          metadataJSON: JSON.parse(attribute.metadataJSON),
                        }}
                        customAttributeType={attribute.value.attributeType}
                        attributeValue={customAttributesValue}
                        setAttributeValue={setCustomAttributesValues}
                        index={index}
                        key={index}
                        errorFields={errorFields}
                        setErrorFields={setErrorFields}
                      />
                    </>
                  );
                })
              ) : (
                <></>
              )}
            </div>
          )}
        </MotifAccordionContent>
      </MotifAccordion>

      <div>
        {isError ? (
          <MotifErrorMessage>
            {t("pages.configuration.attributes.requiredFields")}
          </MotifErrorMessage>
        ) : (
          <></>
        )}
      </div>

      <div className="button-container sticky-footer">
        <Button variant={NEXT_BUTTON_VARIANT} label={t("global.globalActions.next")} onClickHandler={handleNext} />
        <Button
          type="button"
          label={t("global.globalActions.cancel")}
          variant={CANCEL_BUTTON_VARIANT}
          className="cancelBtn"
          onClickHandler={(e) => {
            setIsVisible(true);
            dispatch(setDiscardEditMode({ editMode: false }));

          }}
        />
      </div>

      <ConfirmationModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </div>
  );
}
